import FlagIcon from './FlagIcon';
import { FlagWrap, LanguageSwitcherRoot } from '../LanguageSwitcher.styles';

const LanguageSwitcherTrigger = ({ currentLanguageCode, selectLanguageLabel, open, onToggle }) => (
	<LanguageSwitcherRoot>
		<button
			type="button"
			aria-label={selectLanguageLabel}
			aria-expanded={open}
			onClick={onToggle}
		>
			<FlagWrap aria-hidden="true">
				<FlagIcon code={currentLanguageCode} />
			</FlagWrap>
		</button>
	</LanguageSwitcherRoot>
);

export default LanguageSwitcherTrigger;
